/* istanbul ignore next */
export const setInfuseConfig = (config, brandNew) => ({
  type: 'AUTH_SET_INFUSE_CONFIG',
  config,
  brandNew
});

/* istanbul ignore next */
export const getInfuseConfig = (config) => ({
  type: 'AUTH_GET_INFUSE_CONFIG',
  config
});

/* istanbul ignore next */
export const setInfuseApiResponse = (api) => ({
  type: 'AUTH_SET_INFUSE_API_RESPONSE',
  api
});
